import { render, staticRenderFns } from "./devInfo.vue?vue&type=template&id=2578bcd2&scoped=true&"
import script from "./devInfo.vue?vue&type=script&lang=js&"
export * from "./devInfo.vue?vue&type=script&lang=js&"
import style0 from "./devInfo.vue?vue&type=style&index=0&id=2578bcd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578bcd2",
  null
  
)

export default component.exports